module.exports = __webpack_public_path__ + "img/张红楼.112c57c5.jpg";